/* WINECOM Kollektions- und Suchansicht – eigene Datei, unabhaengig von Vantage
   - Filter, Sortierung, "Weitere Weine laden" ohne Neuladen (Section Rendering API)
   - Aufklappfenster, "Alle Filter", Schnellansicht, In den Warenkorb
   Ohne JavaScript funktionieren alle Filter als normale Links. */
(function () {
  'use strict';

  var ROOT = '[data-wc-listing]';
  var DESKTOP = window.matchMedia('(min-width: 750px)');
  var ui = { panel: null, drawer: false, trigger: null };
  var ctrl = null;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function root() { return $(ROOT); }
  function shopRoot() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  function withSection(url) {
    var r = root();
    var u = new URL(url, location.origin);
    u.searchParams.set('section_id', r.getAttribute('data-section-id'));
    return u.toString();
  }
  function clean(url) {
    var u = new URL(url, location.origin);
    u.searchParams.delete('section_id');
    return u.pathname + u.search;
  }
  function lock(on) { document.documentElement.classList.toggle('wc-lock', !!on); }

  /* ---------- Laden ---------- */
  function fetchSection(url) {
    if (ctrl && ctrl.abort) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    return fetch(withSection(url), { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector(ROOT);
        if (!fresh) throw new Error('no listing');
        return fresh;
      });
  }

  function navigate(url, opts) {
    opts = opts || {};
    var r = root();
    if (!r) { location.href = url; return; }
    var keep = {
      panel: ui.panel ? ui.panel.id : null,
      drawer: ui.drawer,
      drawerScroll: ui.drawer && $('[data-wc-drawer-body]', r) ? $('[data-wc-drawer-body]', r).scrollTop : 0,
      panelScroll: ui.panel && $('.wc-panel__body', ui.panel) ? $('.wc-panel__body', ui.panel).scrollTop : 0
    };
    r.classList.add('is-loading');
    fetchSection(url).then(function (fresh) {
      r.replaceWith(fresh);
      sizeCards();
      stageInit(url);
      ui.panel = null; ui.drawer = false;
      if (opts.push !== false) history.pushState({ wc: 1 }, '', clean(url));
      if (keep.drawer) {
        openDrawer(true);
        var b = $('[data-wc-drawer-body]', fresh); if (b) b.scrollTop = keep.drawerScroll;
      } else if (keep.panel) {
        var p = document.getElementById(keep.panel);
        var t = $('[data-wc-open="' + keep.panel + '"]', fresh);
        if (p && t && isVisible(t)) {
          openPanel(p, t);
          var pb = $('.wc-panel__body', p); if (pb) pb.scrollTop = keep.panelScroll;
        } else { lock(false); }
      } else { lock(false); }
      if (opts.toTop) scrollToList();
    }).catch(function (e) {
      if (e && e.name === 'AbortError') return;
      location.href = url;
    });
  }

  function isVisible(el) { return !!(el && el.offsetParent !== null); }

  function scrollToList() {
    var r = root(); if (!r) return;
    var top = r.getBoundingClientRect().top + window.pageYOffset - 20;
    if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
  }

  /* ---------- Aufklappfenster ---------- */
  /* Die Optionslisten stehen nur einmal im HTML (in "Alle Filter").
     Ein Filterfenster leiht sich die Liste beim Oeffnen und gibt sie beim Schliessen zurueck. */
  function fillPanel(panel) {
    var body = $('[data-wc-fill]', panel); if (!body) return;
    var key = body.getAttribute('data-wc-fill');
    var r = root(); if (!r) return;
    var lists = $$('[data-wc-list]', r);
    for (var i = 0; i < lists.length; i++) {
      if (lists[i].getAttribute('data-wc-list') === key) {
        var l = lists[i];
        if (l.parentNode === body) return;
        l.__wcHome = l.parentNode;
        body.insertBefore(l, body.firstChild);
        return;
      }
    }
  }
  function returnLists() {
    var r = root(); if (!r) return;
    $$('[data-wc-fill] > [data-wc-list]', r).forEach(function (l) {
      if (l.__wcHome && document.contains(l.__wcHome)) l.__wcHome.appendChild(l);
    });
  }
  function closeAll() {
    returnLists();
    if (ui.panel) {
      ui.panel.hidden = true;
      var t = $('[data-wc-open="' + ui.panel.id + '"]');
      if (t) t.setAttribute('aria-expanded', 'false');
    }
    $$('[data-wc-bar].is-open').forEach(function (b) { b.classList.remove('is-open'); });
    var r = root();
    if (r) {
      var d = $('[data-wc-drawer]', r); if (d) d.hidden = true;
      var o = $('[data-wc-overlay]', r); if (o) o.hidden = true;
    }
    var hadFocus = ui.trigger;
    ui.panel = null; ui.drawer = false; ui.trigger = null;
    lock(false);
    if (hadFocus && document.contains(hadFocus)) hadFocus.focus({ preventScroll: true });
  }

  function openPanel(panel, trigger) {
    if (ui.panel && ui.panel !== panel) closeAll();
    fillPanel(panel);
    var bar = panel.closest('[data-wc-bar]');
    panel.hidden = false;
    if (bar) bar.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    ui.panel = panel; ui.trigger = trigger;
    if (DESKTOP.matches) {
      var br = bar.getBoundingClientRect(), tr = trigger.getBoundingClientRect();
      var left = tr.left - br.left;
      var maxLeft = br.width - panel.offsetWidth;
      panel.style.left = Math.max(0, Math.min(left, maxLeft)) + 'px';
      panel.style.top = (tr.bottom - br.top + 8) + 'px';
    } else {
      var o = $('[data-wc-overlay]', root()); if (o) o.hidden = false;
      lock(true);
    }
    var first = $('input, a, button', $('.wc-panel__body', panel));
    if (first && DESKTOP.matches) first.focus({ preventScroll: true });
  }

  function openDrawer(silent) {
    var r = root(); if (!r) return;
    if (ui.panel) closeAll();
    returnLists();
    var d = $('[data-wc-drawer]', r), o = $('[data-wc-overlay]', r);
    d.hidden = false; o.hidden = false; ui.drawer = true;
    lock(true);
    if (!silent) { var x = $('.wc-x', d); if (x) x.focus({ preventScroll: true }); }
  }

  /* ---------- Weitere Weine laden ---------- */
  /* Kartenbreite messen und als Klasse ans Raster haengen (ersetzt Container-Abfragen, Safari) */
  function sizeCards() {
    $$('[data-wc-grid]').forEach(function (g) {
      var c = g.querySelector('.wc-card');
      var w = c ? c.getBoundingClientRect().width : 0;
      g.classList.toggle('wc-cw-345', w > 0 && w <= 345);
      g.classList.toggle('wc-cw-300', w > 0 && w <= 300);
      g.classList.toggle('wc-cw-240', w > 0 && w <= 240);
    });
  }
  var sizeTick = false;
  window.addEventListener('resize', function () {
    if (!sizeTick) { sizeTick = true; requestAnimationFrame(function () { sizeTick = false; sizeCards(); }); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sizeCards); else sizeCards();
  window.addEventListener('load', sizeCards);

  function loadMore(link) {
    var r = root();
    if (r && r.__wcStage) { stageMore(link); return; }
    link.classList.add('is-busy');
    fetchSection(link.href).then(function (fresh) {
      var r = root();
      var grid = $('[data-wc-grid]', r);
      $$('[data-wc-grid] > *', fresh).forEach(function (c) { grid.appendChild(c); });
      var wrap = $('[data-wc-more-wrap]', r);
      var nw = $('[data-wc-more-wrap]', fresh);
      if (wrap) { if (nw) wrap.replaceWith(nw); else wrap.remove(); }
      sizeCards();
    }).catch(function () { location.href = link.href; });
  }

  /* ---------- Nachladen in zwei Stufen (28.10.2026) ----------
     Kollektionen mit mehr als einer Seite: erst alle lieferbaren Weine
     (filter.v.availability=1), danach ein Button fuer die ausverkauften (=0).
     Anzahl, Filter und Adresse bleiben unveraendert. Ohne JavaScript gilt die
     Sortierung je Seite aus winecom-listing.liquid. */
  var AV = 'filter.v.availability';

  function stageUrl(val, base) {
    var u = new URL(base || location.href, location.origin);
    u.searchParams.delete('page');
    u.searchParams.delete(AV);
    u.searchParams.set(AV, val);
    return u.toString();
  }

  function addCards(grid, fresh) {
    var have = {};
    $$('[data-wc-card]', grid).forEach(function (c) { have[c.getAttribute('data-wc-key')] = 1; });
    $$('[data-wc-grid] > *', fresh).forEach(function (c) {
      var k = c.getAttribute('data-wc-key');
      if (k && have[k]) return;
      have[k] = 1;
      grid.appendChild(c);
    });
  }

  function stageWrap(r, href, label) {
    var grid = $('[data-wc-grid]', r);
    var total = parseInt(r.getAttribute('data-wc-total'), 10) || 0;
    var shown = $$('[data-wc-card]', grid).length;
    var pct = total ? Math.min(100, Math.round(shown * 100 / total)) : 100;
    var w = document.createElement('div');
    w.className = 'wc-more';
    w.setAttribute('data-wc-more-wrap', '');
    w.innerHTML = '<p class="wc-more__t"></p><div class="wc-more__bar" aria-hidden="true"><span></span></div>' +
      '<a class="wc-more__btn" data-wc-more></a>';
    $('.wc-more__t', w).textContent = shown + ' von ' + total + ' ' + (r.getAttribute('data-wc-noun-dat') || 'Weinen');
    $('.wc-more__bar span', w).style.width = pct + '%';
    var a = $('[data-wc-more]', w);
    a.href = href;
    a.textContent = label;
    return w;
  }

  function stageSetMore(r, fresh) {
    var old = $('[data-wc-more-wrap]', r); if (old) old.remove();
    var grid = $('[data-wc-grid]', r);
    var next = fresh ? $('[data-wc-more-wrap] [data-wc-more]', fresh) : null;
    var pl = r.getAttribute('data-wc-noun-pl') || 'Weine';
    var w = null;
    if (next) {
      w = stageWrap(r, clean(new URL(next.getAttribute('href'), location.href).toString()), 'Weitere ' + pl + ' laden');
    } else if (r.__wcStage === 1) {
      var n = parseInt(r.getAttribute('data-wc-oos'), 10) || 0;
      var noun = n === 1 ? (r.getAttribute('data-wc-noun-sg') || 'Wein') : pl;
      w = stageWrap(r, stageUrl('0', r.__wcBase), n + ' ausverkaufte ' + noun + ' anzeigen');
      w.querySelector('[data-wc-more]').setAttribute('data-wc-stage-next', '2');
    }
    if (w) grid.insertAdjacentElement('afterend', w);
  }

  /* base = Adresse, aus der diese Liste stammt (bei Filterwechsel die neue Adresse,
     location.href ist dann noch nicht aktualisiert) */
  function stageInit(base) {
    var r = root();
    if (!r || !r.hasAttribute('data-wc-stage') || r.__wcStage) return;
    var grid = $('[data-wc-grid]', r); if (!grid) return;
    r.__wcStage = 1;
    r.__wcBase = clean(base || location.href);
    var oldCards = $$('[data-wc-grid] > *', r);
    var oldWrap = $('[data-wc-more-wrap]', r);
    $$('[data-wc-card][data-wc-avail="0"]', grid).forEach(function (c) { c.remove(); });
    if (oldWrap) oldWrap.remove();
    fetchSection(stageUrl('1', r.__wcBase)).then(function (fresh) {
      if (root() !== r) return;
      /* Liste vollstaendig aus Stufe 1 aufbauen; vorhandene Karten weiterverwenden (kein Flackern) */
      var keep = {};
      oldCards.forEach(function (c) { var k = c.getAttribute('data-wc-key'); if (k) keep[k] = c; });
      var list = [];
      $$('[data-wc-grid] > *', fresh).forEach(function (c) {
        var k = c.getAttribute('data-wc-key');
        list.push(k && keep[k] ? keep[k] : c);
      });
      while (grid.firstChild) grid.removeChild(grid.firstChild);
      list.forEach(function (c) { grid.appendChild(c); });
      stageSetMore(r, fresh);
      sizeCards();
    }).catch(function (e) {
      if (e && e.name === 'AbortError') return;
      /* Rueckfall: Seite wie vom Server geliefert */
      r.__wcStage = 0;
      while (grid.firstChild) grid.removeChild(grid.firstChild);
      oldCards.forEach(function (c) { grid.appendChild(c); });
      if (oldWrap) grid.insertAdjacentElement('afterend', oldWrap);
      sizeCards();
    });
  }

  function stageMore(link) {
    var r = root();
    link.classList.add('is-busy');
    if (link.getAttribute('data-wc-stage-next') === '2') r.__wcStage = 2;
    fetchSection(link.href).then(function (fresh) {
      if (root() !== r) return;
      addCards($('[data-wc-grid]', r), fresh);
      stageSetMore(r, fresh);
      sizeCards();
    }).catch(function (e) {
      if (e && e.name === 'AbortError') return;
      location.href = clean(link.href);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { stageInit(); }); else stageInit();

  /* ---------- Warenkorb ---------- */
  var toastTimer;
  function toast(text, isError) {
    var t = $('.wc-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'wc-toast';
      t.setAttribute('role', 'status');
      t.innerHTML = '<span class="wc-toast__t"></span><a class="wc-toast__a" href="' + shopRoot() + 'cart">Warenkorb ansehen</a>';
      document.body.appendChild(t);
      t.querySelector('.wc-toast__a').addEventListener('click', function (e) {
        var trig = $('.js-mini-cart-trigger');
        if (trig) { e.preventDefault(); t.classList.remove('is-shown'); trig.click(); }
      });
    }
    t.querySelector('.wc-toast__t').textContent = text;
    t.querySelector('.wc-toast__a').hidden = !!isError;
    t.classList.toggle('is-error', !!isError);
    requestAnimationFrame(function () { t.classList.add('is-shown'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-shown'); }, 4000);
  }

  function refreshThemeCart(cart) {
    try {
      var cfgEl = document.getElementById('cart-config');
      if (cfgEl && window.Shopify && Shopify.theme && Shopify.theme.ajaxCart && Shopify.theme.ajaxCart.updateView) {
        Shopify.theme.ajaxCart.updateView(JSON.parse(cfgEl.innerHTML || '{}'), cart);
      }
    } catch (e) { /* Theme-Warenkorb nicht verfuegbar */ }
    $$('.js-cart-count, [data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
  }

  function addToCart(form) {
    var btn = $('[type="submit"]', form);
    var id = Number(form.querySelector('[name="id"]').value);
    var qInput = form.querySelector('[name="quantity"]');
    var qty = Math.max(1, parseInt(qInput ? qInput.value : '1', 10) || 1);
    if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }
    fetch(shopRoot() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    }).then(function (res) {
      return res.json().then(function (data) { if (!res.ok) throw data; return data; });
    }).then(function () {
      return fetch(shopRoot() + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    }).then(function (cart) {
      refreshThemeCart(cart);
      toast(qty + ' × ' + (form.getAttribute('data-title') || 'Wein') + ' im Warenkorb');
    }).catch(function (err) {
      toast((err && err.description) ? err.description : 'Das hat leider nicht geklappt. Bitte versuche es erneut.', true);
    }).then(function () {
      if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); }
    });
  }

  function stepQty(btn) {
    var wrap = btn.closest('.wc-qty'); if (!wrap) return;
    var input = $('input', wrap);
    var step = parseInt(input.getAttribute('step') || '1', 10) || 1;
    var min = parseInt(input.getAttribute('min') || '1', 10) || 1;
    var val = parseInt(input.value || min, 10) || min;
    val += parseInt(btn.getAttribute('data-wc-step'), 10) * step;
    input.value = Math.max(min, Math.min(999, val));
  }

  /* ---------- Schnellansicht ---------- */
  var qv, qvTrigger;
  function qvModal() {
    if (qv) return qv;
    qv = document.createElement('div');
    qv.className = 'wc-qv';
    qv.hidden = true;
    qv.innerHTML = '<div class="wc-qv__bg" data-wc-qv-close></div>' +
      '<div class="wc-qv__box" role="dialog" aria-modal="true" aria-labelledby="wc-qv-title">' +
      '<button type="button" class="wc-x" data-wc-qv-close aria-label="Schließen"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<div class="wc-qv__inner"></div></div>';
    document.body.appendChild(qv);
    return qv;
  }
  function openQuickView(url, trigger) {
    var m = qvModal();
    var inner = $('.wc-qv__inner', m);
    qvTrigger = trigger;
    inner.innerHTML = '<p class="wc-qv__loading">Wird geladen …</p>';
    m.hidden = false; lock(true);
    $('.wc-x', m).focus({ preventScroll: true });
    var tpl = qvTemplate(trigger);
    if (tpl) { inner.innerHTML = tpl.innerHTML; return; }
    quickHtml(url)
      .then(function (html) { if (qvTrigger === trigger) inner.innerHTML = html; })
      .catch(function () { location.href = url; });
  }

  /* Schnellansicht steht als <template> in der Karte; nur ohne Vorlage wird nachgeladen */
  function qvTemplate(el) {
    var card = el && el.closest ? el.closest('[data-wc-card]') : null;
    return card ? card.querySelector('template[data-wc-qv-tpl]') : null;
  }
  /* Schnellansicht vorladen: beim Ueberfahren der Karte bzw. des Buttons */
  var qvCache = {};
  function quickHtml(url) {
    if (qvCache[url]) return qvCache[url];
    var u = new URL(url, location.origin);
    u.searchParams.set('view', 'wc-quick');
    qvCache[url] = fetch(u.toString(), { credentials: 'same-origin' })
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.text(); })
      .catch(function (e) { delete qvCache[url]; throw e; });
    return qvCache[url];
  }
  var hoverTimer;
  document.addEventListener('pointerover', function (e) {
    var t = e.target instanceof Element ? e.target.closest('[data-wc-card]') : null;
    if (!t) return;
    var b = t.querySelector('[data-wc-qv]');
    if (!b || qvTemplate(b)) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () { quickHtml(b.getAttribute('data-wc-qv')).catch(function () {}); }, 250);
  });
  document.addEventListener('touchstart', function (e) {
    var b = e.target instanceof Element ? e.target.closest('[data-wc-qv]') : null;
    if (b && !qvTemplate(b)) quickHtml(b.getAttribute('data-wc-qv')).catch(function () {});
  }, { passive: true });
  function closeQuickView() {
    if (!qv || qv.hidden) return false;
    qv.hidden = true; lock(false);
    if (qvTrigger && document.contains(qvTrigger)) qvTrigger.focus({ preventScroll: true });
    return true;
  }

  /* ---------- Suche in Optionslisten ---------- */
  function findInList(input) {
    var scope = input.closest('.wc-panel__body, .wc-dsec, .wc-side__group') || input.parentNode.parentNode;
    var list = $('[data-wc-opts]', scope); if (!list) return;
    var q = input.value.trim().toLowerCase();
    var hits = 0;
    list.classList.toggle('is-searching', q !== '');
    $$('.wc-opt', list).forEach(function (o) {
      var l = ($('.wc-opt__l', o) || o).textContent.toLowerCase();
      var hit = q === '' || l.indexOf(q) !== -1;
      o.classList.toggle('is-filtered-out', !hit);
      if (hit) hits++;
    });
    var empty = $('.wc-opts__empty', list); if (empty) empty.hidden = hits > 0;
    var more = $('[data-wc-showall]', scope); if (more) more.hidden = q !== '';
  }

  /* ---------- Ereignisse ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;

    if (t.closest('[data-wc-qv-close]')) { e.preventDefault(); closeQuickView(); return; }

    var r = root();
    var inListing = r && r.contains(t);
    var inQv = qv && qv.contains(t);
    if (!inListing && !inQv) {
      if (ui.panel && DESKTOP.matches) closeAll();
      return;
    }

    var qvBtn = t.closest('[data-wc-qv]');
    if (qvBtn) { e.preventDefault(); closeAll(); openQuickView(qvBtn.getAttribute('data-wc-qv'), qvBtn); return; }

    var step = t.closest('[data-wc-step]');
    if (step) { e.preventDefault(); stepQty(step); return; }

    if (!inListing) return;

    var nav = t.closest('a[data-wc-nav]');
    if (nav) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      var href = nav.href;
      var single = nav.getAttribute('data-wc-single');
      if (single && nav.getAttribute('aria-checked') !== 'true' && !nav.classList.contains('is-active')) {
        var u = new URL(href, location.origin);
        u.searchParams.delete(single);
        u.searchParams.append(single, nav.getAttribute('data-wc-value'));
        u.searchParams.delete('page');
        href = u.toString();
      }
      navigate(href);
      return;
    }

    var more = t.closest('a[data-wc-more]');
    if (more) { e.preventDefault(); loadMore(more); return; }

    var opener = t.closest('[data-wc-open]');
    if (opener) {
      e.preventDefault();
      var p = document.getElementById(opener.getAttribute('data-wc-open'));
      if (!p) return;
      if (ui.panel === p) closeAll(); else openPanel(p, opener);
      return;
    }

    if (t.closest('[data-wc-open-drawer]')) { e.preventDefault(); openDrawer(); return; }

    var closer = t.closest('[data-wc-close]');
    if (closer) {
      e.preventDefault();
      var toTop = closer.hasAttribute('data-wc-totop');
      closeAll();
      if (toTop) scrollToList();
      return;
    }

    if (t.closest('[data-wc-overlay]')) { closeAll(); return; }

    var showAll = t.closest('[data-wc-showall]');
    if (showAll) {
      e.preventDefault();
      var scope = showAll.parentNode;
      var list = $('[data-wc-opts]', scope);
      if (list) list.classList.add('is-all');
      showAll.hidden = true;
      return;
    }

    if (ui.panel && DESKTOP.matches && !t.closest('[data-wc-panel]')) closeAll();
  });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!(f instanceof HTMLFormElement)) return;
    if (f.hasAttribute('data-wc-add')) { e.preventDefault(); addToCart(f); }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('select[data-wc-sort]')) {
      var form = t.form;
      var params = new URLSearchParams(new FormData(form));
      navigate(form.getAttribute('action') + '?' + params.toString());
    }
  });

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-wc-find]')) findInList(t);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (closeQuickView()) return;
    if (ui.panel || ui.drawer) closeAll();
  });

  window.addEventListener('popstate', function () {
    if (root()) navigate(location.href, { push: false });
  });

  DESKTOP.addEventListener && DESKTOP.addEventListener('change', function () { if (ui.panel) closeAll(); });

  /* Mobil: Filterzeile unter einem fixierten Theme-Header halten */
  var ticking = false;
  function stickyOffset() {
    ticking = false;
    var r = root(); if (!r) return;
    var h = 0;
    $$('.stickynav.sticky--active').forEach(function (el) {
      var cs = getComputedStyle(el);
      if ((cs.position === 'fixed' || cs.position === 'sticky') && el.offsetParent !== null) {
        var rect = el.getBoundingClientRect();
        if (rect.top <= 1) h = Math.max(h, rect.bottom);
      }
    });
    r.style.setProperty('--wc-sticky-top', Math.round(h) + 'px');
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(stickyOffset); }
  }, { passive: true });
  window.addEventListener('resize', stickyOffset);
})();
